export const INVALID_CAPTCHA_TOKEN_CODE = 'iam/invalid_captcha_token'

export const CAPTCHA_TOKEN_HEADER = 'recaptcha-token'
